import { useMemo } from 'react'

import useAuth from 'hooks/use-auth'
import {
  largeScaleTestReportsIdGet,
  largeScaleTestReportsPagedGet,
  largeScaleTestsActiveGet,
  largeScaleTestsDraftGet,
  largeScaleTestsIdCompletePost,
  largeScaleTestsIdDelete,
  largeScaleTestsIdGet,
  largeScaleTestsIdHaltAllPost,
  largeScaleTestsIdPut,
  largeScaleTestsIdRunAllPost,
  largeScaleTestsIdServiceRunPost,
  largeScaleTestsPost,
  policiesServiceIdReliabilityReportGet,
  scenariosHaltIdRunsRunNumberPost,
  scenariosIdRunsGet,
  scenariosIdRunsPost
} from 'utils/endpoints-access'

export function useGetLargeScaleTestPermissions() {
  const { hasEndpointAccess, hasEndpointAccessForAll } = useAuth()

  const accessValues = useMemo(() => {
    return {
      canCompleteLargeScaleTests: hasEndpointAccess(
        largeScaleTestsIdCompletePost
      ),
      canCreateLargeScaleTests: hasEndpointAccess(largeScaleTestsPost),
      canDeleteLargeScaleTests: hasEndpointAccess(largeScaleTestsIdDelete),
      canHaltAllLargeScaleTests: hasEndpointAccess(
        largeScaleTestsIdHaltAllPost
      ),
      canReadLargeScaleTests: hasEndpointAccessForAll([
        largeScaleTestsActiveGet,
        largeScaleTestsDraftGet,
        largeScaleTestsIdGet
      ]),
      canReadLargeScaleTestReports: hasEndpointAccessForAll([
        largeScaleTestReportsIdGet,
        largeScaleTestReportsPagedGet
      ]),
      canRunAllLargeScaleTests: hasEndpointAccess(largeScaleTestsIdRunAllPost),
      canUpdateLargeScaleTests: hasEndpointAccess(largeScaleTestsIdPut),
      getCanHaltLargeScaleTests: (teamId?: string) =>
        hasEndpointAccess(largeScaleTestsIdHaltAllPost) ||
        (teamId &&
          hasEndpointAccess(scenariosHaltIdRunsRunNumberPost, { teamId })),
      getCanRunLargeScaleTests: (teamId?: string) =>
        hasEndpointAccess(largeScaleTestsIdRunAllPost) ||
        hasEndpointAccess(largeScaleTestsIdServiceRunPost) ||
        (teamId && hasEndpointAccess(scenariosIdRunsPost, { teamId })),
      getCanViewLargeScaleTestServiceRunDetails: (teamId?: string) =>
        hasEndpointAccess(largeScaleTestsIdGet) ||
        (teamId &&
          (hasEndpointAccess(policiesServiceIdReliabilityReportGet, {
            teamId
          }) ||
            hasEndpointAccess(scenariosIdRunsGet, { teamId })))
    }
  }, [hasEndpointAccess, hasEndpointAccessForAll])

  return accessValues
}
